<app-header></app-header>
<app-about></app-about>
<app-example></app-example>
<app-features></app-features>
<app-author></app-author>
